import type { ReactNode } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'
import Clickable from 'components/Common/Clickable'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import BodyText from 'LuxKit/Typography/BodyText'
import { REBRAND_PALETTE_CLASS } from 'lib/theme/paletteVersion'

const Card = styled(Clickable)`
  display: flex;
  flex-direction: column;
  height: 100%;
  gap: ${rem(16)};
`

export const FlightMarketingCardHero = styled.div`
  aspect-ratio: 5 / 3;
  position: relative;
  overflow: hidden;

  body.${REBRAND_PALETTE_CLASS} & {
    border-radius: var(--border-radius-m);
  }
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  justify-content: space-between;
  gap: ${rem(12)};
`

interface Props {
  to: string
  hero: ReactNode
  title: ReactNode
  description?: ReactNode
  children: ReactNode
  'data-testid'?: string
}

export default function FlightMarketingCard(props: Props) {
  const { to, hero, title, description, children, 'data-testid': testId } = props

  return (
    <Card to={to} data-testid={testId}>
      {hero}
      <Content>
        <VerticalSpacer gap={8}>
          <BodyText variant="large" weight="bold">{title}</BodyText>
          {description}
        </VerticalSpacer>
        {children}
      </Content>
    </Card>
  )
}
